<template>
  <div>
    <h1>{{ msg }}</h1>
  </div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Help'
    }
  }
}
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Help.vue